module.exports = __webpack_public_path__ + "static/media/youtube.503d2e22.svg";